import { UPDATE_CUSTOMER_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class UpdateCustomerError extends ApiError {
  constructor() {
    super(UPDATE_CUSTOMER_ERROR);
  }
}
